import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';

const NotFound = () => {
  return (
    <div className="min-h-screen bg-secondary">
      <Navbar />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 text-center">
        <h1 className="text-9xl font-serif font-bold text-primary">404</h1>
        <h2 className="text-4xl font-serif font-bold text-gray-900 mt-4">Page Not Found</h2>
        <p className="mt-4 text-lg text-gray-600 font-sans">
          Sorry, we couldn't find the page you're looking for. It might have been removed or the link might be broken.
        </p>
        <div className="mt-8">
          <Link
            to="/"
            className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-primary hover:bg-green-800 transition shadow-sm"
          >
            Go Back Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFound;